var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHandshake = function SvgHandshake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18.99694,
    viewBox: "0 0 32 18.99694",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,23H3a2,2,0,0,0,2-2V10H0Zm3-3a1,1,0,1,1-1,1A1,1,0,0,1,3,20Z",
    transform: "translate(0 -7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,10H27V21a2,2,0,0,0,2,2h3ZM30,21a1,1,0,1,1-1-1A1,1,0,0,1,30,21Z",
    transform: "translate(0 -7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.195,20.525l-7.465-6.06-1.5,1.375a3.599,3.599,0,0,1-4.865-5.305L14.455,7h-4.19a1.63009,1.63009,0,0,0-1.191.31476L6,9.99V21H7l4.84,4.28a3.19936,3.19936,0,0,0,4.5-.465l.00995-.01.895.775a1.85812,1.85812,0,0,0,2.615-.27l1.57-1.93.27.22a1.59751,1.59751,0,0,0,2.25-.235l.475-.585A1.6029,1.6029,0,0,0,24.195,20.525Z",
    transform: "translate(0 -7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.735,7H17.44a1.67107,1.67107,0,0,0-1.14878.26967L11.445,11.71c-.005.005-.01.015-.015.02a1.98889,1.98889,0,0,0-.105,2.8,2.08534,2.08534,0,0,0,2.805.135c.005-.005.015-.005.02-.01l3.995-3.66a.7998.7998,0,1,1,1.08,1.18L17.92,13.37l7.68183,5.91A3.63259,3.63259,0,0,1,26,19.665V10L22.865,7.26A1.66035,1.66035,0,0,0,21.735,7Z",
    transform: "translate(0 -7)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandshake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handshake.88a83418.svg";
export { ForwardRef as ReactComponent };